import { render, staticRenderFns } from "./WaitingSales.vue?vue&type=template&id=0ba3fc5a"
import script from "./WaitingSales.vue?vue&type=script&lang=js"
export * from "./WaitingSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports